<div class="wallet_s_single_wrapper synergy-single coop-single row">
  <div class="s_single col-md-12">

    <div appSticky position="top" class="row s_single-title-container">
      <div class="col-md-12">
        <h1 class="s_single-title">{{partner.name}}</h1>
      </div>
    </div>
    <div class="row s_single-img-area">
      <div class="col-md-12 s_single-img-container partner-img-container">
        <div class="s_single-img partner-img">
          <img src={{avatar}} alt={{partner.name}} />
          <!-- <img src={{partner.imageURL}} alt={{partner.name}} /> -->
        </div>
      </div>
      <!-- <div class="s_single-category">{{partner.sector | sector_filter}}</div> -->
      <div class="s_single-category">{{partner.sector | sector_filter: (sectorList$ | async)}}</div>
    </div>
    <div class="row s_single-details">
      <div class="col-md-12">
        <div class="row s_single-info-container">
          <div class="col-md-6 s_single-info">
            <div *ngIf="partner.address" class="info-row info-addess" (click)="scrollTo('map-widget-partner')">
              <span class="mdi mdi-pin"></span>
              {{partner.address.street}}, {{partner.address.city}}
            </div>
            <div *ngIf="partner.phone" class="info-row"><span class="mdi mdi-phone"></span>{{partner.phone}}
            </div>
            <div class="info-row"><span class="mdi mdi-email"></span>{{partner.email}}</div>
            <div *ngIf="contactsList">
              <div class="contacts" *ngFor="let contact of contactsList">
                <a *ngIf="contact.value" href="{{contact.prefix}}{{contact.value}}" target="_blank"><span
                    class="mdi mdi-{{contact.icon}}"></span> </a>
              </div>
            </div>
            <!-- <div *ngIf="partner.contact" class="info-row"><span class="mdi mdi-web"></span><a target="_blank"
                href="{{partner.contact.websiteURL}}">{{partner.contact.websiteURL}}</a></div> -->
          </div>
          <div *ngIf="partner.timetable" class="col-md-6 hours">
            <p [innerHTML]="partner.timetable"></p>
          </div>
        </div>
        <div class="row s_single-description">
          <div class="col-md-12">
            <p [innerHTML]="partner.description"></p>
          </div>
        </div>
      </div>
    </div>

    <!--begin::Microcredit Campaigns List-->
    <sng-microcredit_campaigns-list-carousel [partner]='partner' type="'single'">
    </sng-microcredit_campaigns-list-carousel>
    <!--end::Microcredit Campaigns List-->

    <!--begin::Loyalty Offers List-->
    <sng-offers-list-carousel [partner]='partner' type="'single'"></sng-offers-list-carousel>
    <!--end::Loyalty Offers List-->

    <!--begin::Post/Events List-->
    <sng-posts_events-list-carousel [partner]='partner' type="'single'" [access]="null">
    </sng-posts_events-list-carousel>
    <!--end::Post/Events List-->

    <!--begin::Map Widget-->
    <sng-map id="map-widget-partner" [partner_id]='partner._id'></sng-map>
    <!--end::Map Widget-->

  </div>
</div>